import Index from "../components/Schedule/Index.vue";
import Programming from "../components/Schedule/Programming.vue";

let routes = {
    path: "/schedules",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/schedule",
            name: "Planejamento",
            component: Index
        },
        {
            path: "/programming",
            name: "Programação",
            component: Programming
        },
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/schedule.js